import WorkIcon from '@mui/icons-material/Work';

const ProjectIcon = (props) => {
    const {...other} = props;
    return (
        <WorkIcon {...other}/>
    )
}

export default ProjectIcon;